/* tslint:disable */

export class ExecutionRequestData {
		Key: number;
		Value: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ExecutionRequestData.ts